import { SelectBatteryPage,queryBatteryCountDrawing,queryBatteryOrganizationPage,queryBatterySinglePage } from "../../api/config/modules/BatteryAnalysis";

const state = {
    SelectBatteryPage: {},
    queryBatteryCountDrawing: {},
    queryBatteryOrganizationPage: {},
    queryBatterySinglePage: {}
};

const mutations = {
  SET_SELECTBATTERYPAGE: (state, SelectBatteryPage) => {
    state.SelectBatteryPage = SelectBatteryPage;
  },
  SET_QUERYBATTERYCOUNTDRAWING: (state, queryBatteryCountDrawing) => {
    state.queryBatteryCountDrawing = queryBatteryCountDrawing;
  },
  SET_QUERYBATTERYORGANIZATIONPAGE: (state, queryBatteryOrganizationPage) => {
    state.queryBatteryOrganizationPage = queryBatteryOrganizationPage;
  },
  SET_QUERYBATTERYSINGLEPAGE: (state, queryBatterySinglePage) => {
    state.queryBatterySinglePage = queryBatterySinglePage;
  }
};

const actions = {
  GET_SELECTBATTERYPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        SelectBatteryPage(data)
        .then((res) => {
          commit("SET_SELECTBATTERYPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYCOUNTDRAWING: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryCountDrawing(data)
        .then((res) => {
          commit("SET_QUERYBATTERYCOUNTDRAWING", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYORGANIZATIONPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatteryOrganizationPage(data)
        .then((res) => {
          commit("SET_QUERYBATTERYORGANIZATIONPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYBATTERYSINGLEPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryBatterySinglePage(data)
        .then((res) => {
          commit("SET_QUERYBATTERYSINGLEPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
